import { tableBotApi } from "../Api"
import { AxiosResponse } from "axios";
import { SharedExtractResponse } from "../../../models/table/ITableExtract";
import {IProductsPaymentRequest} from "../../../models/table/IProductsPaymentRequest";

export const CommandTableApi = () => {
    const getTableExtract = async (commandId: string, paymentLinkId: string): Promise<AxiosResponse<{ value: SharedExtractResponse }>> => {
        return await tableBotApi.get(`/commands/${commandId}/payments/balance/${paymentLinkId}`);
    }

    const generateReservationPayment = async (data: IProductsPaymentRequest, commandId: string, paymentLinkId: string) => {
        return await tableBotApi.post(`/commands/${commandId}/payments/${paymentLinkId}/reservation`, data);
    }

    return {
        getTableExtract,
        generateReservationPayment
    }
}

